import React, { FunctionComponent } from 'react';
import { 
    Modal, 
    ModalHeader, 
    ModalActions, 
    ButtonPrimary, 
    Button, 
    InputText 
} from '../../../components-v2/shared';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

interface SmsTestModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSendSms: (phoneNumber: string) => void;
    defaultPhoneNumber?: string;
    isLoading?: boolean;
}

interface FormValues {
    phoneNumber: string;
}

const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
        .required('Phone number is required')
        .matches(
            /^[\+]?[1-9][\d]{0,15}$/,
            'Please enter a valid phone number (e.g., +1234567890 or 1234567890)'
        )
});

export const SmsTestModal: FunctionComponent<SmsTestModalProps> = ({
    isOpen,
    onClose,
    onSendSms,
    defaultPhoneNumber = '',
    isLoading = false
}) => {
    const initialValues: FormValues = {
        phoneNumber: defaultPhoneNumber
    };

    const handleSubmit = (values: FormValues) => {
        onSendSms(values.phoneNumber);
    };

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader title="Send Test SMS" />
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {(formikProps) => (
                    <Form>
                        <div style={{ padding: '20px' }}>
                            <p>Enter the phone number where you'd like to receive the test SMS:</p>
                            <InputText
                                name="phoneNumber"
                                label="Phone Number"
                                placeholder="e.g., +1234567890 or 1234567890"
                                formikProps={formikProps}
                                disabled={isLoading}
                            />
                        </div>
                        <ModalActions>
                            <Button onClick={onClose} disabled={isLoading}>
                                Cancel
                            </Button>
                            <ButtonPrimary 
                                type="submit" 
                                disabled={isLoading || !formikProps.isValid}
                            >
                                {isLoading ? 'Sending...' : 'Send Test SMS'}
                            </ButtonPrimary>
                        </ModalActions>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};
